import { Component, Input, OnInit } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { PedidoConsultaInternaOutput } from "src/app/@shared/models/consulta-detalhes-interno";
import { environment } from "src/environments/environment";

@Component({
  selector: "app-bloco-reentrega-interno",
  templateUrl: "./bloco-reentrega.component.html",
  styleUrls: ["./bloco-reentrega.component.scss"],
})
export class BlocoReentregaInternoComponent implements OnInit {
  @Input("Pedido") pedido: any;
  displayedColumns: string[] = ["nrtRelacionada", "tipoPedido"];
  dataSource: any[];
  isLoading: boolean = false;

  constructor(public snackBar: MatSnackBar) {}

  ngOnInit() {
    if (this.pedido) this.carregarReeentregas();
  }

  carregarReeentregas() {
    this.isLoading = true;
    this.dataSource = this.pedido?.reentregas;
    this.isLoading = false;
  }

  refresh() {
    this.isLoading = true;
    setTimeout(() => {
      window.location.reload();
    }, 100);
  }

  openSnackBar(
    message: string,
    action: string,
    duration: number,
    panelClass?: string
  ): any {
    this.snackBar.open(message, action, { duration, panelClass });
  }
}
